import { getZonedDate } from '@eika-infrastruktur/date';

import { CreateOutboxPayment } from '../../../../fetchHooks/useOutbox';
import type { PaymentRequest } from '../../../../generated-types';
import nullableZonedDateToUtc from '../../../../utils/mapper/nullableZonedDateToUtc';
import { PaymentState } from './state';

export default (state: PaymentState): CreateOutboxPayment => {
    const paymentDate = state.paymentDate ?? getZonedDate();
    const getKid = () => {
        if (state.immediate || !state.toAccount?.kidFormats?.length) return undefined;
        if (state.kid?.value) return state.kid;
        return undefined;
    };

    const kid = getKid();
    const text = kid ? undefined : state.note;

    const request: PaymentRequest = {
        fromAccountNumber: state.fromAccount!,
        toAccount: state.toAccount!.accountNumber,
        toAccountName: state.toAccount!.accountName,
        amount: state.amount!,
        currency: 'NOK',
        kid,
        text,
        paymentDate: nullableZonedDateToUtc(paymentDate)!,
        receiptType: state.receiptType,
        ownText: state.ownText,
        immediate: state.immediate,
        deviceId: window.ReactNativeProps?.deviceId,
    };
    return {
        paymentRequest: request,
        acceptDuplicate: true,
    };
};
